import SectionHeading from "./SectionHeading";
import { collections } from "@/mocks/catalog";

export default function Collections() {
  return (
    <section id="collections" className="w-full bg-background-100 py-16 md:py-24">
      <div className="mx-auto w-full max-w-content px-4 md:px-8">
        <SectionHeading
          eyebrow="合集组织"
          title="合集不只是「打包」，三种整理思路对应三种需求"
          desc="合集的价值在于减少挑选成本。按年份、主题或口碑来组织，得到的浏览体验完全不同，选对思路比多看几部更重要。"
        />

        <div className="mt-10 flex flex-col gap-6">
          {collections.map((collection, index) => {
            const reversed = index % 2 === 1;
            return (
              <article
                key={collection.id}
                className="grid grid-cols-1 overflow-hidden rounded-lg border border-background-200/70 bg-background-50 lg:grid-cols-2"
              >
                <div className={`relative h-56 w-full lg:h-full lg:min-h-[260px] ${reversed ? "lg:order-2" : ""}`}>
                  <img
                    src={collection.image}
                    alt={`${collection.name}示意封面`}
                    className="h-full w-full object-cover object-top"
                  />
                  <span className="absolute left-4 top-4 flex h-10 w-10 items-center justify-center rounded-md bg-primary-500 font-heading text-sm font-semibold text-background-50">
                    {String(index + 1).padStart(2, "0")}
                  </span>
                </div>
                <div className={`p-5 md:p-8 ${reversed ? "lg:order-1" : ""}`}>
                  <h3 className="font-heading text-xl font-semibold text-foreground-950">{collection.name}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-foreground-600">{collection.desc}</p>
                  <ul className="mt-5 flex flex-col gap-3">
                    {collection.points.map((point) => (
                      <li key={point} className="flex items-start gap-2.5 text-sm text-foreground-700">
                        <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-accent-100 text-accent-700">
                          <i className="ri-check-line text-sm"></i>
                        </span>
                        {point}
                      </li>
                    ))}
                  </ul>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}